import axios from 'axios';
import config from '../Config'; // Path to your config file
import authHeader from './auth-header'; // Path to your auth header


const API_URL = config.API_URL; // Base API URL
const API_VERSION = config.API_VERSION; // API version
const addVehicleType = (formData) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/vehicletype/`,
    formData, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
const getVehicleTypeList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/vehicletype/`, {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getVehicleTypeDropdown = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/vehicletype/`, {
    headers: authHeader(),
    params: {
      fields: 'id, name, deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getVehicleTypeArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/vehicletype-archive', {
    headers: authHeader(), params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    }
  });
};
const updateVehicleType = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/vehicletype/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
// const deleteVehicleType = (id) => {
//   return axios.post(
//     `${API_URL}/api/${API_VERSION}/vehicletype/${id}/archive/`, // Include the die group's ID in the URL
//     {},
//     { headers: authHeader() } // Authentication header
//   );
// };
const deleteVehicleType = (id) => {
   
  return axios.delete(
      `${API_URL}/api/${API_VERSION}/vehicletype/${id}/`,
      { headers: authHeader() }, // Authentication header
    );
};
const unArchiveVehicleType = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/vehicletype/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() } // Authentication header
  );
};
const vehicleTypeService = {
  addVehicleType,
  getVehicleTypeList,
  getVehicleTypeArchiveList,
  updateVehicleType,
  deleteVehicleType,
  unArchiveVehicleType,
  getVehicleTypeDropdown
};

export default vehicleTypeService;
